import React from "react";
// Common Components
import {
  DynamicDropdown,
  Button,
  TextInput,
  DynamicMultiSelectDropdown,
  StaticDropdown,
} from "src/Components";
// Request
import { getPairType, getBaseType } from "src/Requests/synthetic";
import { getStepInstruments } from "src/Requests/stepRequests";
import { getBaseInstruments } from "src/Requests/Order/tradeTableRequests";
// Types
import { IPairPositionSearchParams } from "src/Interfaces/Synthetic";
import { ExchangeType } from "src/Interfaces/connections";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";

const exchangeTypeOption: DropdownItem[] = [
  { id: ExchangeType.StockExchange, name: "اوراق بهادار" },
  { id: ExchangeType.CommodityExchange, name: "کالا" },
];

interface IProps {
  searchParamChangeHandler: (name: string, value: any) => void;
  searchParam: IPairPositionSearchParams;
  onSubmit: () => void;
}

const PairPositionSearchParamUI: React.FC<IProps> = ({
  searchParam,
  searchParamChangeHandler,
  onSubmit,
}) => {
  return (
    <div className="border border-gray-300 rounded p-3 flex flex-col gap-3 !w-[350px] !min-w-[350px]">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full min-w-0">
        <DynamicMultiSelectDropdown
          dropdown={{
            name: "pairType",
            placeholder: "نوع جفت",
            extraLabel: true,
          }}
          getData={getPairType}
          onChange={searchParamChangeHandler}
          value={searchParam?.pairType}
        />

        <DynamicDropdown
          dropdown={{
            name: "baseType",
            placeholder: "نوع پایه",
            extraLabel: true,
          }}
          getData={getBaseType}
          onChange={searchParamChangeHandler}
          value={searchParam?.baseType?.toString() || ""}
        />
        <DynamicMultiSelectDropdown
          dropdown={{
            name: "baseInstrument",
            placeholder: "نماد پایه",
            extraLabel: true,
          }}
          getData={() => getBaseInstruments()}
          onChange={searchParamChangeHandler}
          value={searchParam?.baseInstrument}
        />

        <StaticDropdown
          dropdown={{
            name: "exchangeType",
            placeholder: "بورس",
            extraLabel: true,
          }}
          onChange={searchParamChangeHandler}
          options={exchangeTypeOption}
          value={searchParam?.exchangeType?.toString() || ""}
        />

        <DynamicDropdown
          dropdown={{
            name: "buySideInstrument",
            placeholder: "نماد سمت خرید",
            extraLabel: true,
          }}
          getData={getStepInstruments}
          onChange={searchParamChangeHandler}
          value={searchParam?.buySideInstrument?.toString() || ""}
        />

        <DynamicDropdown
          dropdown={{
            name: "sellSideInstrument",
            placeholder: "نماد سمت فروش",
            extraLabel: true,
          }}
          getData={getStepInstruments}
          onChange={searchParamChangeHandler}
          value={searchParam?.sellSideInstrument?.toString() || ""}
        />

        <TextInput
          name="minYearlyProfit"
          label="حداقل درصد بازده سالانه"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.minYearlyProfit?.toString() || ""}
          kind="negativeDecimalNumbers"
        />

        <TextInput
          name="maxYearlyOffestProfit"
          label="حداکثر درصد بازده سالانه"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.maxYearlyOffestProfit?.toString() || ""}
          kind="negativeDecimalNumbers"
        />

        <TextInput
          name="minCallITMPercentSide1"
          label="حداقل درصد ITM کال سمت خرید"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.minCallITMPercentSide1?.toString() || ""}
          kind="negativeDecimalNumbers"
        />

        <TextInput
          name="minPutITMPercentSide1"
          label="حداقل درصد ITM پوت سمت خرید"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.minPutITMPercentSide1?.toString() || ""}
          kind="negativeDecimalNumbers"
        />

        <TextInput
          name="minCallITMPercentSide2"
          label="حداقل درصد ITM کال سمت فروش"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.minCallITMPercentSide2?.toString() || ""}
          kind="negativeDecimalNumbers"
        />

        <TextInput
          name="minPutITMPercentSide2"
          label="حداقل درصد ITM پوت سمت فروش"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.minPutITMPercentSide2?.toString() || ""}
          kind="negativeDecimalNumbers"
        />

        <TextInput
          label="حداقل روز تا سررسید به خرید"
          onChange={searchParamChangeHandler}
          name="minBuysideRemainingDay"
          value={searchParam.minBuysideRemainingDay?.toString()}
          extraLabel
          kind="number"
        />

        <TextInput
          name="maxBuysideRemainingDay"
          label="حداکثر روز تا سررسید به خرید"
          extraLabel
          kind="number"
          onChange={searchParamChangeHandler}
          value={searchParam?.maxBuysideRemainingDay?.toString()}
        />

        <TextInput
          name="minSellsideRemainingDay"
          label="حداقل روز تا سررسید به فروش"
          extraLabel
          kind="number"
          onChange={searchParamChangeHandler}
          value={searchParam?.minSellsideRemainingDay?.toString()}
        />

        <TextInput
          name="maxSellsideRemainingDay"
          label="حداکثر روز تا سررسید به فروش"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.maxSellsideRemainingDay?.toString()}
        />

        <TextInput
          name="minYesterdayValue"
          label="حداقل ارزش معاملاتی رو ز قبل"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.minYesterdayValue?.toString() || ""}
          kind="price"
        />

        <TextInput
          name="minLastTradeValue"
          label="حداقل حجم معاملات روز قبل"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.minLastTradeValue?.toString() || ""}
          kind="price"
        />
      </div>
      <Button onClick={onSubmit} text="جستجو" variant="contained" />
    </div>
  );
};

export default PairPositionSearchParamUI;
